import Service from './Service';

export default class DataUploadService extends Service {
    constructor() {
        super();
        this.baseURL = 'storemanagement/dataupload/';
    }


}